module.exports = __webpack_public_path__ + "static/media/how_to_verify.384a7634.pdf";